import { getCurrentLocaleCode } from "@mongez/localization";
import { LocalizationValue } from "../types";

export function getLocalizedValue(
  localeValue: LocalizationValue | string,
): string {
  if (!localeValue) return "";

  if (typeof localeValue === "object") {
    return localeValue[getCurrentLocaleCode()] || "";
  }

  return localeValue;
}
